import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../modals/redux/modalActions';

const actions = {
  closeModal,
};

class ModalImagePopup extends Component {
  render() {
    const { data, size, closeModal } = this.props;
    const url = data;
    return (
      <div className='modal is-active'>
        <div className='modal-background' onClick={closeModal}></div>
        <div className='modal-content'>
          <div className='image has-text-centered'>
            <button
              onClick={closeModal}
              className='delete'
              aria-label='close'
              style={{top: 5, right: 5, position: 'absolute'}}
            ></button>
            <img
              src={url}
              alt='preview'
              style={{
                display: 'block',
                objectFit: 'cover',
                width: size ? `${size}%` : '100%',
                height: 'auto',
              }}
            />
          </div>
        </div>
        <button
          className='modal-close is-large'
          aria-label='close'
          onClick={closeModal}
        ></button>
      </div>
    );
  }
}

export default connect(null, actions)(ModalImagePopup);
